import React from 'react';
import { Box, Typography, useTheme, useMediaQuery, ThemeProvider } from '@mui/material';
import { ModalHot } from '../ModalHot';
import { ButtonHot } from '../ButtonHot';
import { appTheme } from 'common/theme';
import { generateTestId } from '../../../app/functions';

export const GeneralModal = ({
  open,
  onClose,
  children,
  buttonText = 'אישור',
  onButtonClick,
  hasButton = true,
  testID = 'general-modal',
  maxWidth = 400,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleButtonClick = () => {
    if (onButtonClick) {
      onButtonClick();
    }
    onClose?.();
  };

  const renderContent = () => {
    if (!children) return null;

    if (typeof children === 'string') {
      if (children.includes('<') && children.includes('>')) {
        return (
          <Typography
            variant="body1"
            component="div"
            testID={generateTestId(testID, 'content')}
            sx={{
              color: 'text.primary',
              mb: 3,
              lineHeight: 1.6,
              '& a': {
                color: 'primary.main',
                textDecoration: 'underline',
              },
            }}
            dangerouslySetInnerHTML={{ __html: children }}
          />
        );
      }
      return (
        <Typography
          variant="body1"
          testID={generateTestId(testID, 'content')}
          sx={{
            color: 'text.primary',
            mb: 3,
            lineHeight: 1.6,
          }}
        >
          {children}
        </Typography>
      );
    }

    return (
      <Box sx={{ mb: 3 }} testID={generateTestId(testID, 'content')}>
        {children}
      </Box>
    );
  };

  return (
    <ModalHot
      open={open}
      onClose={onClose}
      testID={testID}
      maxWidth={maxWidth}
    >
      <ThemeProvider theme={appTheme}>
        <Box
          testID={generateTestId(testID, 'wrapper')}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            width: '100%',
          }}
        >
          {renderContent()}

          {hasButton && (
            <ButtonHot
              testID={generateTestId(testID, 'button')}
              onClick={handleButtonClick}
              variant="primary"
              size={isMobile ? 'medium' : 'large'}
            >
              {buttonText}
            </ButtonHot>
          )}
        </Box>
      </ThemeProvider>
    </ModalHot>
  );
};

export default GeneralModal;
